export enum LESSONS_LEARNT_MODULES {
  LESSONS_LEARNT_REGISTER = 'LESSONS_LEARNT_REGISTER',
  LESSONS_LEARNT_WELL = 'LESSONS_LEARNT_WELL',
  LESSONS_LEARNT_VIEW = 'LESSONS_LEARNT_VIEW',
}

export const lessonsLearntModules = Object.values(LESSONS_LEARNT_MODULES);
